import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["optionsContainer", "template"]
  
  connect() {
    // Initialiser le contrôleur
    this.updateOptionsVisibility()
  }
  
  addOption(event) {
    const questionContainer = this.element
    const questionId = questionContainer.dataset.id
    const optionsContainer = this.optionsContainerTarget
    const template = this.templateTarget
    
    // Trouver les indices pour les attributs imbriqués
    const sectionFieldset = questionContainer.closest('.form-section')
    const sectionIndex = Array.from(sectionFieldset.parentNode.children).indexOf(sectionFieldset)
    const questionIndex = Array.from(questionContainer.parentNode.children).indexOf(questionContainer)
    const newOptionIndex = new Date().getTime()
    
    // Cloner le template et remplacer les indices
    const clone = template.content.cloneNode(true)
    const input = clone.querySelector('input')
    input.name = input.name
      .replace('IDX1', sectionIndex)
      .replace('IDX2', questionIndex)
      .replace('NEWIDX', newOptionIndex)
    
    // Ajouter l'option au conteneur
    optionsContainer.appendChild(clone)
  }
  
  removeOption(event) {
    const button = event.currentTarget
    const optionDiv = button.closest('div')
    
    // Si l'option a un champ _destroy, on le marque comme détruit
    const destroyField = optionDiv.querySelector('.destroy-field')
    if (destroyField) {
      destroyField.value = 'true'
      optionDiv.style.display = 'none'
    } else {
      // Sinon on la supprime directement (pour les nouvelles options)
      optionDiv.remove()
    }
  }
  
  updateOptionsVisibility(event) {
    const questionContainer = this.element
    const typeSelect = questionContainer.querySelector('select[name*="question_type"]')
    const optionsContainer = this.hasOptionsContainerTarget ? this.optionsContainerTarget.parentElement : null
    
    if (typeSelect && optionsContainer) {
      const type = typeSelect.value
      if (type === 'simple' || type === 'multiple') {
        optionsContainer.style.display = 'block'
      } else {
        optionsContainer.style.display = 'none'
      }
    }
  }
}
